import { render, staticRenderFns } from "./ProductWindow.vue?vue&type=template&id=0610ad94&scoped=true&"
import script from "./ProductWindow.vue?vue&type=script&lang=js&"
export * from "./ProductWindow.vue?vue&type=script&lang=js&"
import style0 from "./ProductWindow.vue?vue&type=style&index=0&id=0610ad94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0610ad94",
  null
  
)

export default component.exports